import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

const styles = `
  @keyframes fadeIn {
    0% { opacity: 0; transform: translateY(20px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  .accessdenied-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 20px;
    background-color: #ffffff;
  }
  .accessdenied-card {
    background-color: #ffffff;
    padding: 40px;
    max-width: 500px;
    width: 100%;
    text-align: center;
    border: 1px solid #fca5a5;
    border-radius: 20px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    animation: fadeIn 0.6s ease-out forwards;
  }
  .accessdenied-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }
  .accessdenied-title {
    font-size: 2rem;
    font-weight: bold;
    color: #b91c1c;
    margin-bottom: 10px;
  }
  .accessdenied-message {
    font-size: 1rem;
    color: #7f1d1d;
    margin-bottom: 30px;
  }
  .accessdenied-button {
    display: inline-block;
    background-color: #dc2626;
    color: white;
    padding: 10px 24px;
    font-size: 1rem;
    font-weight: 500;
    text-decoration: none;
    border-radius: 8px;
    transition: background-color 0.3s ease;
  }
  .accessdenied-button:hover {
    background-color: #b91c1c;
  }
`;

const AccessDenied = () => {
  return (
    <>
      <style>{styles}</style>
      <div className="accessdenied-wrapper">
        <div className="accessdenied-card">
          <div className="accessdenied-icon-wrapper">
            <Lock size={80} strokeWidth={1.5} color="#dc2626" />
          </div>
          <h1 className="accessdenied-title">Access Denied</h1>
          <p className="accessdenied-message">
            You don’t have permission to view this page.
          </p>
          <Link to="/login" className="accessdenied-button">
            Go to Dashboard
          </Link>
        </div>
      </div>
    </>
  );
};

export default AccessDenied;
